import { AhPlusModal } from "./AhPlusModal";
import type { AhPlusModalProps } from "./AhPlusModal.d";

export type { AhPlusModalProps };
export { AhPlusModal };
